import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import { WizardPage } from './pages/WizardPage';
import { QuizPage } from './pages/QuizPage';
import { TheoryStudioPage } from './pages/TheoryStudioPage';
import { MindmapPage } from './pages/MindmapPage';

export const App: React.FC = () => {
  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WizardPage />} />
          <Route path="/mindmap" element={<MindmapPage />} />
          <Route path="/quiz/:lessonId" element={<QuizPage />} />
          <Route path="/lesson/:lessonId" element={<TheoryStudioPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
};

export default App;
